import React from 'react';
import slugify from '../../../../../../scripts/utils/slugify';
import {ISearchFilter, ISearchFilterOption} from '../../../../../context/search/types';
import useSearch from '../../../../../context/search/useSearch';

interface IMultiOptionFilter {
  filterIndex: number,
  filter: ISearchFilter,
}

const SingleOptionFilter: React.FC<IMultiOptionFilter> = ({filterIndex, filter}): JSX.Element => {

  const {inputEventHandlers} = useSearch()

  const tagHandler = (label: string): string => {
    return label.includes('roast') && filter.raw.prefix === 'roast' ? label.split('roast')[1].trim() : label
  }
  
  return (
    <React.Fragment>
      <div className={'sf-search-filter-single-options sf-search-filter-options'}>
        { 
          (filter.options as ISearchFilterOption[]).map((option: ISearchFilterOption, index: number) => {
            const slug = `${slugify(option.identifier)}-${index}`
            const disabled = option.records < 1 && !option.selected;
            return (
              <React.Fragment key={index}>
                <div className={`sf-search-filter-single-option sf-search-filter-option ${option.selected ? 'is-selected' : ''} ${disabled ? 'is-disabled' : ''}`}>
                  <label htmlFor={option.selected ? `${slug}-off` : `${slug}-on`}>
                    <span className={'sf-search-filter-single-option-label'}>{tagHandler(option.label)} ({option.records})</span>
                  </label>
                  <input id={`${slug}-on`} name={slug} className="visually-hidden" checked={option.selected} disabled={option.records === 0} type="radio" onChange={(e) => inputEventHandlers.handleToggleSingleOption(filterIndex, index, e.target.checked)} />
                  <input id={`${slug}-off`} name={slug} className="visually-hidden" checked={!option.selected} disabled={option.records === 0} type="radio"  onChange={(e) => inputEventHandlers.handleToggleSingleOption(filterIndex, index, !e.target.checked)} />
                </div>
              </React.Fragment>
            )
          })}
      </div>
    </React.Fragment>
  )
}

export default SingleOptionFilter